// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__Layout__3ibvi{display:flex;flex-direction:column;padding:var(--Space-12) var(--Space-24)}.styles-module__Sections__3vryh{row-gap:var(--Space-24)}.styles-module__Section__l-r2R{row-gap:var(--Space-12)}.styles-module__List__3OFH7{padding-left:var(--Space-12);margin:0}.styles-module__Header__1xPYl{align-items:center}.styles-module__Highlighted__21oGi{background-color:#fbf0d5}", ""]);
// Exports
exports.locals = {
	"Layout": "styles-module__Layout__3ibvi",
	"Sections": "styles-module__Sections__3vryh",
	"Section": "styles-module__Section__l-r2R",
	"List": "styles-module__List__3OFH7",
	"Header": "styles-module__Header__1xPYl",
	"Highlighted": "styles-module__Highlighted__21oGi"
};
export default exports;
